import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { z } from "zod";
import { ensureElementVisible } from "@/lib/route-guards";

const SprzWybranychBlozowPage = lazy(() => import("@/features/reports/sprz-wybranych-blozow-page"));

// `.catch(undefined)` na kazdym polu — zly param ze starego bookmarka ma zostac
// zignorowany, a nie wywalic trase ZodErrorem.
// Raport dotyczy wylacznie aptek wlasnych — nie ma parametru zakresu. Podzial
// STAŁA BAZA / TOTAL nalezy do raportow zbiorczych, nie do tego (w FM1 jest tu
// zwykla kolumna `sprz_w_2_okresach`).
const searchSchema = z.object({
	listId: z.coerce.number().int().positive().optional().catch(undefined),
	mode: z.enum(["full", "toYesterday"]).optional().catch(undefined),
	apteka: z.enum(["z-internetowa"]).optional().catch(undefined),
});

export type SprzWybranychBlozowSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/raporty/sprz-wybranych-blozow/")({
	beforeLoad: async ({ context, location }) => {
		// Raport widzi szerszy krag niz jego konfiguracja (purchaser czyta, nie edytuje).
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.sprz-wybranych-blozow",
			location.pathname,
		);
	},
	component: SprzWybranychBlozowPage,
	validateSearch: (search: Record<string, unknown>): SprzWybranychBlozowSearch =>
		searchSchema.parse(search),
});
